import { put, call } from 'redux-saga/effects';

import { Types } from './actions';

import ExamnStragglesRepository from '@/domain/repositories/ExamStragglesRepository';
import ExamsStragglesDataRepository from '@/data/repositories/ExamStragglesDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const { requestId } = action;
    yield put({ type: Types.ACTIVATE_PAYMENT_COURSES_REQUEST });
    XCheckpointManager.registerStart('Examen de rezagados - activar pago');

    const examStragglesRepository: ExamnStragglesRepository =
      new ExamsStragglesDataRepository();
    const examSstragglesResponse = yield call(
      examStragglesRepository.activatePaymentLateCourses,
      requestId
    );

    if (!examSstragglesResponse) {
      yield put({ type: Types.ACTIVATE_PAYMENT_COURSES_FAILURE, error: true });
      return;
    }

    yield put({
      type: Types.ACTIVATE_PAYMENT_COURSES_SUCCESS,
      data: examSstragglesResponse.requestId
    });
    XCheckpointManager.registerEnd('Examen de rezagados - activar pago');
  } catch (error) {
    yield put({
      type: Types.ACTIVATE_PAYMENT_COURSES_FAILURE,
      error: 'Ocurrió un error al momento de solicitar los datos.'
    });
  }
}
